/* eslint-disable react-hooks/exhaustive-deps */
import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Grid, Button } from "@mui/material";
import AutoCompleteInput from "../../../Components/FormComponents/AutoCompleteInput";
import TextFieldInput from "Components/FormComponents/TextFieldInput";
import NumberInput from "Components/FormComponents/NumberInput";
import {
  getCarInfoCompanyByType,
  getCarInfoModelByType,
  getCarModelCodeByType,
} from "../../MainBody/api";
import { useTranslation } from "react-i18next";
import {
  SelectOption,
  CarTypeCompanyInfo,
  CarInfoModelType,
  CarModelCodeType,
  ChildRef,
} from "./type";
import { IS_UPDATING, IS_UPDATING_VI_CODE } from "./constants";
import { normalizeString, normalizeText } from "Common/common";
import { listOptionManufactureYear } from "./listOption";
import { checkIsModelCode } from "Common/common";
import { isEmpty } from "lodash";
import { listHideCarBrand } from "./constants";
import useStyles from "../useStyles";
import { OTHER } from "./constants";

interface SpecializedVehicleFormProps {
  onValueChange: (value: string) => void;
  dataFormImage: any;
  setDataFromImage: any;
}

const SpecializedVehicle = forwardRef<ChildRef, SpecializedVehicleFormProps>(
  ({ onValueChange, dataFormImage, setDataFromImage }, ref) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [openCarModel, setOpenCarModel] = useState<boolean>(false);

    const [selectedCarCompany, setSelectedCarCompany] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedModel, setSelectedModel] = useState<SelectOption>({
      id: "",
      label: "",
    });

    const [selectedModelCode, setSelectedModelCode] = useState<SelectOption>({
      id: "",
      label: "",
    });

    const [selectedManufactured, setSelectedManufactured] =
      useState<SelectOption>({ id: "", label: "" });
    const [weight, setWeight] = useState<string>("");
    const [specializedVehicle, setSpecializedVehicle] = useState<string>("");
    const vehicleInspectionOcrIdRef = useRef(0);

    const [otherValue, setOtherValue] = useState<string>("");

    const [listCarCompany, setListCarCompany] = useState<SelectOption[]>([]);
    const [listCarInfoModel, setListCarInfoModel] = useState<SelectOption[]>(
      [],
    );
    const [listModelCode, setListModelCode] = useState<SelectOption[]>([]);

    const [modelCodeInput, setModelCodeInput] = useState<string>("");

    useImperativeHandle(ref, () => ({
      triggerAction: handleTrigger,
    }));

    const handleTrigger = () => {
      resetSelect();
    };

    const resetSelect = () => {
      setSelectedCarCompany({ id: "", label: "" });
      setSelectedModel({ id: "", label: "" });
      setSelectedModelCode({ id: "", label: "" });
      setSelectedManufactured({ id: "", label: "" });
      setWeight("");
      setDataFromImage(null);
      vehicleInspectionOcrIdRef.current = 0;
    };

    useEffect(() => {
      if (otherValue !== "") {
        if (checkIsModelCode(otherValue, listModelCode) !== -1)
          setSelectedModelCode(
            listModelCode[checkIsModelCode(otherValue, listModelCode)],
          );
      }
    }, [otherValue]);

    useEffect(() => {
      (async () => {
        const getCarInfo: CarTypeCompanyInfo[] = await getCarInfoCompanyByType(
          "specialized",
          1000,
        );
        let newListOption: SelectOption[] = [];
        if (getCarInfo && getCarInfo.length > 0) {
          getCarInfo.forEach((company) => {
            const option: SelectOption = {
              id: company.companyKey,
              label: company.companyName,
            };

            newListOption.push(option);
          });
          listHideCarBrand.forEach((element) => {
            newListOption = newListOption.filter(
              (option) => option.id !== element,
            );
          });
          setListCarCompany(newListOption);
        }

        if (dataFormImage) {
          const nameOfCarCompany = dataFormImage?.predictedCarCompany;
          const findCarCompany = newListOption.find(
            (company) => company?.label === nameOfCarCompany,
          );
          if (findCarCompany) {
            setSelectedCarCompany(findCarCompany);
          } else {
            setSelectedCarCompany({ id: OTHER, label: nameOfCarCompany });
          }
        }
      })();
    }, [listHideCarBrand, dataFormImage]);

    useEffect(() => {
      if (selectedCarCompany?.id !== "") {
        if (selectedCarCompany.id === OTHER) {
          if (dataFormImage && dataFormImage?.predictedCarModel) {
            setSelectedModel({
              id: OTHER,
              label: dataFormImage?.predictedCarModel,
            });
            return;
          }
          setSelectedModel({ id: OTHER, label: "" });
          return;
        }
        setSelectedModel({ id: "", label: "" });
        setListCarInfoModel([]);
        (async () => {
          const listCarInfoModel: CarInfoModelType[] =
            await getCarInfoModelByType(
              "specialized",
              selectedCarCompany?.id || "",
              1000,
            );
          const newListOption: SelectOption[] = [];

          if (listCarInfoModel && listCarInfoModel.length > 0) {
            listCarInfoModel.forEach((model) => {
              const option: SelectOption = {
                id: `${model.versionKey}${model.modelCode}`,
                label: `${model.versionName} (${model.modelCode})`,
                versionKey: model.versionKey,
                modelCode: model.modelCode,
              };
              newListOption.push(option);
            });
            setListCarInfoModel(newListOption);
          }
          if (dataFormImage) {
            const nameOfCarModel = dataFormImage?.predictedCarModel;
            const findCarModel =
              nameOfCarModel !== IS_UPDATING
                ? newListOption.find((model) =>
                    normalizeText(model?.label).includes(
                      normalizeText(nameOfCarModel),
                    ),
                  )
                : newListOption.find(
                    (model) =>
                      model?.id ===
                      normalizeString(dataFormImage.predictedCarVersion) +
                        IS_UPDATING_VI_CODE,
                  );
            if (findCarModel) {
              setSelectedModel(findCarModel);
            } else {
              setSelectedModel({ id: OTHER, label: nameOfCarModel });
            }
          }
        })();
      } else {
        setSelectedModel({ id: "", label: "" });
      }
    }, [selectedCarCompany, dataFormImage]);

    useEffect(() => {
      if (selectedModel?.id !== "" && selectedCarCompany?.id !== "") {
        setListModelCode([]);
        setSelectedModelCode({ id: "", label: "" });
        setOtherValue("");
        setWeight("");
        setSpecializedVehicle("");
        setSelectedManufactured({ id: "", label: "" });
        setModelCodeInput("");
        if (selectedModel.id === OTHER) {
          setSelectedModelCode({ id: OTHER, label: "Khác" });
          if (dataFormImage?.modelCode) {
            setModelCodeInput(dataFormImage?.modelCode);
          }
          if (dataFormImage && dataFormImage?.predictedYear) {
            const nameOfManufactured = dataFormImage?.predictedYear;
            const findManufactured = listOptionManufactureYear.find(
              (manufactured) =>
                manufactured?.label === nameOfManufactured.toString(),
            );
            if (findManufactured) setSelectedManufactured(findManufactured);
          }
          if (dataFormImage?.carType)
            setSpecializedVehicle(dataFormImage?.carType);
          return;
        }
        (async () => {
          const listModelCode: CarModelCodeType[] = await getCarModelCodeByType(
            "specialized",
            selectedCarCompany.id,
            selectedModel.versionKey,
            1000,
          );
          if (!isEmpty(listModelCode)) {
            const currentModelCode: any = listModelCode.find(
              (item: any) => item.modelCode === selectedModel.modelCode,
            );
            setSelectedModelCode({
              id: currentModelCode.modelCode,
              label: currentModelCode.modelCode,
              carTypeName: currentModelCode.carTypeName,
              payload: currentModelCode.payload,
            });
            setModelCodeInput(currentModelCode.modelCode);
            if (
              dataFormImage &&
              dataFormImage?.modelCode &&
              dataFormImage?.modelCode !== currentModelCode.modelCode
            ) {
              setSelectedModelCode({ id: OTHER, label: "Khác" });
              setModelCodeInput(dataFormImage?.modelCode);
            }
          }

          if (dataFormImage && dataFormImage.predictedCarModel) {
            const nameOfCarModel = dataFormImage.predictedCarModel;
            const findCarModel = listModelCode.find((model: any) =>
              model?.label?.includes(nameOfCarModel),
            );
            if (findCarModel) setSelectedModel(findCarModel as any);
          }

          if (dataFormImage && dataFormImage.predictedYear) {
            const nameOfManufactured = dataFormImage.predictedYear;
            const findManufactured = listOptionManufactureYear.find(
              (manufactured) =>
                manufactured?.label === nameOfManufactured.toString(),
            );
            if (findManufactured) setSelectedManufactured(findManufactured);
          }
        })();
      } else {
        setSelectedModelCode({ id: "", label: "" });
        setOtherValue("");
        setWeight("");
        setSpecializedVehicle("");
        setSelectedManufactured({ id: "", label: "" });
        setModelCodeInput("");
      }
    }, [selectedModel, selectedCarCompany, dataFormImage]);

    useEffect(() => {
      if (!selectedModelCode) {
        setSelectedModelCode({ id: "", label: "" });
        setWeight("");
        setSpecializedVehicle("");
        setSelectedManufactured({ id: "", label: "" });
        setOtherValue("");
      }
      if (selectedModelCode?.id === OTHER) {
        setWeight("");
      } else if (selectedModelCode?.id !== OTHER) {
        setOtherValue("");
        setSpecializedVehicle(selectedModelCode?.carTypeName ?? "");
        setWeight(
          selectedModelCode?.payload
            ? selectedModelCode?.payload.toString()
            : "",
        );
      }
    }, [selectedModelCode]);

    useEffect(() => {
      onValueChange(
        JSON.stringify({
          company: selectedCarCompany,
          model: selectedModel,
          modelCode: selectedModelCode,
          otherValue: modelCodeInput,
          weight,
          specializedVehicle,
          selectedManufactured,
        }),
      );
    }, [
      onValueChange,
      selectedCarCompany,
      selectedModel,
      selectedModelCode,
      weight,
      specializedVehicle,
      selectedManufactured,
      otherValue,
    ]);

    const isValidate =
      selectedCarCompany?.id !== "" &&
      selectedModel?.id !== "" &&
      specializedVehicle !== "" &&
      selectedManufactured?.id !== "" &&
      ((selectedModelCode?.id !== "" && selectedModelCode?.id !== OTHER) ||
        (selectedModelCode?.id === OTHER && modelCodeInput !== ""));

    const handleModelCodeInputChange = (value: string) => {
      setModelCodeInput(value);
      if (selectedModelCode?.id !== OTHER) {
        setSelectedModelCode({ id: OTHER, label: "Khác" });
      }
      setOtherValue(value);
    };

    return (
      <>
        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label={t("form.selection.brand.title")}
            listOption={listCarCompany}
            onChange={setSelectedCarCompany}
            value={selectedCarCompany}
            placeholder={t("form.selection.brand.placeholder")}
            onClose={() => {
              setOpenCarModel(true);
            }}
            onOpen={() => {
              setOpenCarModel(false);
            }}
          />
        </Grid>
        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label="Hiệu xe - Phiên bản"
            listOption={listCarInfoModel}
            onChange={setSelectedModel}
            value={selectedModel}
            disabled={selectedCarCompany.id === ""}
            disabledReset={selectedCarCompany?.id === OTHER}
            placeholder={t("form.selection.model.placeholder")}
            open={selectedCarCompany?.id !== "" && openCarModel}
            onClose={() => {
              setOpenCarModel(false);
            }}
            onOpen={() => {
              setOpenCarModel(!openCarModel);
            }}
          />
        </Grid>
        <Grid item md={5.5} xs={12}>
          <TextFieldInput
            label="Số loại"
            onChange={handleModelCodeInputChange}
            value={modelCodeInput}
            placeholder="Số loại"
          />
        </Grid>
        <Grid item md={5.5} xs={12}>
          <NumberInput
            name="weight"
            label="Tải trọng"
            onChange={setWeight}
            value={weight}
            disabled={selectedModelCode?.id === ""}
            placeholder="Tải trọng"
          />
        </Grid>
        <Grid item md={5.5} xs={12}>
          <TextFieldInput
            label="Loại xe chuyên dụng"
            onChange={setSpecializedVehicle}
            value={specializedVehicle}
            disabled={!selectedModelCode}
            placeholder="Loại xe chuyên dụng"
          />
        </Grid>
        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label={t("form.selection.manufacture-year.title")}
            listOption={listOptionManufactureYear}
            onChange={setSelectedManufactured}
            value={selectedManufactured}
            placeholder="Năm sản xuất"
            disabled={selectedModelCode?.id === ""}
          />
        </Grid>

        <Grid item xs={12} md={12} display="flex" justifyContent="center">
          <Button
            className={classes.valueButton}
            style={{
              background: `${isValidate ? "#5768FF" : "#f0f0f0"}`,
              color: `${isValidate ? "#ffffff" : "#bdbdbd"}`,
            }}
            disabled={!isValidate}
            type="submit"
          >
            Tra cứu
          </Button>
        </Grid>
      </>
    );
  },
);

export default SpecializedVehicle;
